"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var tinycolor2_1 = __importDefault(require("tinycolor2"));
var localization_1 = require("@scuf/localization");
var Swatches = /** @class */ (function (_super) {
    __extends(Swatches, _super);
    function Swatches() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderSwatches = function () {
            var data = _this.genRows();
            return data.map(function (row, index) {
                return (React.createElement("div", { className: "swatch-row", key: index }, row.map(function (color) { return _this.renderSwatch(color, index); })));
            });
        };
        _this.renderSwatch = function (color, index) {
            var active = (_this.props.activeColor && tinycolor2_1.default.equals(_this.props.activeColor, color)) ? ' active' : '';
            return (React.createElement("div", { className: 'swatch-item' + active, onClick: function () { return _this.props.onSelect(color); }, key: color + index },
                React.createElement("div", { className: "swatch", style: { background: color } })));
        };
        return _this;
    }
    Swatches.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "heading" },
                React.createElement(localization_1.Translation, { transKey: "Swatches" })),
            React.createElement("div", { className: "swatch-wrapper" }, this.renderSwatches())));
    };
    Swatches.prototype.genRows = function () {
        var colCount = 6;
        var rows = [];
        for (var i = 0; i < this.props.palette.length; i++) {
            var row = Math.floor(i / colCount);
            if (rows[row] === undefined) {
                rows[row] = [];
            }
            rows[row].push(this.props.palette[i]);
        }
        return rows;
    };
    return Swatches;
}(react_1.Component));
exports.default = Swatches;
